// src/pages/departments/DepartmentsPage/components/DepartmentActionMenu.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Typography,
  Menu,
  MenuItem,
  ListItemIcon,
} from '@mui/material';
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
  Extension as ExtensionIcon,
  Block as BlockIcon,
  RestartAlt as RestartAltIcon,
  EventBusy as EventBusyIcon,
  Public as PublicIcon,
  PublicOff as PublicOffIcon,
} from '@mui/icons-material';

export default function DepartmentActionMenu({
  anchorEl,
  open,
  onClose,
  department,
  onEdit,
  onModules,
  onDeactivate,
  onDelete,
  onResetOverdue,
  onGenerateHolidays,
  onGlobalFiles,
  canUpdate,
  canDelete,
  canResetOverdue,
  canAdminGenerateHolidays,
}) {
  const { t } = useTranslation(["departments"]);

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      PaperProps={{
        elevation: 3,
      }}
    >
      {canUpdate && (
        <MenuItem onClick={() => { onEdit(department); onClose(); }}>
          <ListItemIcon>
            <EditIcon fontSize="small" />
          </ListItemIcon>
          {t('departments:actions.edit')} {t('departments:title', { count: 1 })}
        </MenuItem>
      )}

      {onModules && (
        <MenuItem onClick={() => { onModules(department); onClose(); }}>
          <ListItemIcon>
            <ExtensionIcon fontSize="small" />
          </ListItemIcon>
          {t('departments:actions.manage_modules')}
        </MenuItem>
      )}

      {/* The department whose shared folders every department sees */}
      {canUpdate && department && !department.deactivated_at && (
        <MenuItem onClick={() => { onGlobalFiles(department); }}>
          <ListItemIcon>
            {department.manages_global_files ? <PublicOffIcon fontSize="small" /> : <PublicIcon fontSize="small" />}
          </ListItemIcon>
          {department.manages_global_files
            ? t('departments:actions.unset_global_files')
            : t('departments:actions.set_global_files')}
        </MenuItem>
      )}

      {canUpdate && department && !department.deactivated_at && (
        <MenuItem onClick={() => { onDeactivate(department); }}>
          <ListItemIcon>
            <BlockIcon fontSize="small" color="warning" />
          </ListItemIcon>
          <Typography color="warning.main">{t('departments:actions.deactivate')}</Typography>
        </MenuItem>
      )}

      {canResetOverdue && (
        <MenuItem onClick={() => { onResetOverdue(department); }}>
          <ListItemIcon>
            <RestartAltIcon fontSize="small" color="warning" />
          </ListItemIcon>
          <Typography color="warning.main">{t('departments:actions.reset_overdue')}</Typography>
        </MenuItem>
      )}

      {canAdminGenerateHolidays && (
        <MenuItem onClick={() => { onGenerateHolidays(department); onClose(); }}>
          <ListItemIcon>
            <EventBusyIcon fontSize="small" />
          </ListItemIcon>
          {t('departments:actions.generate_holidays')}
        </MenuItem>
      )}

      {canDelete && (
        <MenuItem onClick={() => { onDelete(department); }}>
          <ListItemIcon>
            <DeleteIcon fontSize="small" color="error" />
          </ListItemIcon>
          <Typography color="error">{t('departments:actions.delete')}</Typography>
        </MenuItem>
      )}
    </Menu>
  );
}